import React from 'react';
import ContactsDistributeModalTitleView from '../components/ContactsDistributeModalTitleView';
export default [
    {
        key: 'ContactsDistributeModal',
        getComponent: function () { return import('./ContactsDistributeModal'); },
        title: (React.createElement(ContactsDistributeModalTitleView, { title: i18n.get('部门'), subTitle: i18n.get('(注：已下发或建立“子企业”部门不可下发)') })),
        width: 600,
        maskClosable: false,
        wrapClassName: 'vertical-center-modal select-member-modal',
    },
    {
        key: 'LogModal',
        getComponent: function () { return import('./LogModal'); },
        title: '下发记录',
        width: 800,
    },
];
